(() => {
  let cartPromise = null;
  const ensureCart = () => {
    const container = document.getElementById('x-cart-drawer-container');
    if (!container || window.location.pathname === '/cart') return Promise.resolve();
    if (container.dataset.zentamineCartReady === 'ready') return Promise.resolve();
    if (cartPromise) return cartPromise;
    container.setAttribute('aria-busy', 'true');
    const address = new URL(location.href);
    address.searchParams.set('sections', 'cart-drawer');
    cartPromise = fetch(address).then(response => {
      if (!response.ok) throw new Error('Cart drawer load failed');
      return response.json();
    }).then(sections => {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
      const content = doc.querySelector('#ajax-loading-cart');
      if (!content) throw new Error('Missing cart drawer section');
      container.innerHTML = content.innerHTML;
      container.dataset.zentamineCartReady = 'ready';
      return new Promise(resolve => window.Alpine.nextTick(resolve));
    }).finally(() => {
      container.removeAttribute('aria-busy');
      cartPromise = null;
    });
    return cartPromise;
  };
  window.ZentamineCart = { ensure: ensureCart };
  document.addEventListener('pointerdown', event => {
    if (event.target.closest?.('#cart-icon')) ensureCart().catch(() => {});
  }, { capture: true, passive: true });

  const selector = '[data-zentamine-lazy-card]';
  const waiting = new Set();
  const observed = new WeakSet();
  let ready = false;
  const hydrate = card => {
    if (!card.isConnected || card.dataset.zentamineLazyCard === 'ready') return;
    if (!ready || !window.Alpine) { waiting.add(card); return; }
    waiting.delete(card);
    observer?.unobserve(card);
    window.Alpine.mutateDom(() => {
      if (typeof window.Alpine.destroyTree === 'function') window.Alpine.destroyTree(card);
      delete card._x_ignore;
      delete card._x_ignoreSelf;
      delete card._x_marker;
      card.removeAttribute('x-ignore');
      card.dataset.zentamineLazyCard = 'ready';
      window.Alpine.initTree(card);
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) hydrate(entry.target); });
  }, { rootMargin: '0px 0px 150px 0px' }) : null;
  const observe = card => {
    if (observed.has(card) || card.dataset.zentamineLazyCard === 'ready') return;
    observed.add(card);
    if (observer) observer.observe(card); else hydrate(card);
  };
  const scan = node => {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) observe(node);
    node.querySelectorAll(selector).forEach(observe);
  };
  document.querySelectorAll(selector).forEach(observe);
  document.addEventListener('alpine:initialized', () => {
    ready = true;
    waiting.forEach(hydrate);
  }, { once: true });
  const activate = event => {
    const card = event.target.closest?.(selector);
    if (card) hydrate(card);
  };
  ['pointerdown', 'focusin'].forEach(type => document.addEventListener(type, activate, { capture: true, passive: true }));
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan)))
    .observe(document.body, { childList: true, subtree: true });
})();
